import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { noop } from '@synergy/utils';

import { GoodsCounterAccounts } from '../models/goods-counter-accounts';
import { TaxRate } from '../models/tax-rate';

export class TaxRatesApi {
    constructor(protected baseUrl: string) {}

    public cget = async (params?: URLSearchParams): Promise<ApiResult<PaginatedResponse<TaxRate>>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/tax-rates`, { params }),
            response => response.data
        );

    public cgetAll = async (): Promise<ApiResult<TaxRate[]>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/all-tax-rates`),
            response => response.data
        );

    /** The accounts goods are booked to by default for an invoice address in this country (#2263). */
    public getGoodsCounterAccounts = async (country: string): Promise<ApiResult<GoodsCounterAccounts>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/tax-rates/goods-counter-accounts`, { params: { country } }),
            response => response.data
        );

    public updateTaxRate = async (taxRate: TaxRate): Promise<ApiResult<TaxRate>> =>
        safeRequest(
            () => request.patch(`${this.baseUrl}/tax-rates/${taxRate.id}`, taxRate),
            response => response.data
        );

    public createTaxRate = async (taxRate: Partial<TaxRate>): Promise<ApiResult<TaxRate>> =>
        safeRequest(
            () => request.post(`${this.baseUrl}/tax-rates`, taxRate),
            response => response.data
        );

    public deleteTaxRate = async (taxRateId: number): Promise<ApiResult<void>> =>
        safeRequest(() => request.delete(`${this.baseUrl}/tax-rates/${taxRateId}`), noop);
}
